import { COLORS } from '@btime/constants'
import { isEmpty, propOr } from 'ramda'
import React, { useState } from 'react'

import { SubItem } from '../../../../components/structure/SubItems'
import { Text } from '../../../../components/presentation/Text'
import Link from '../../../../components/actions/Link'
import Separator from '../../../../components/helpers/Separator'
import ServiceOrdersLoader from '../_load/ServiceOrdersLoader'
import ServiceOrdersTable from './ServiceOrdersTable'

const ActionPlansTable = ({ serviceOrder }) => {
  const children = propOr([], 'children', serviceOrder)
  const childrenLength = propOr(0, 'childrenLength', serviceOrder)
  const canLoadMore = children.length < childrenLength
  const [showAll, setShowAll] = useState(false)

  if (!isEmpty(children) && !showAll) {
    const missingLength = childrenLength - children.length
    return (
      <div>
        <ServiceOrdersTable isChildrenTable useSubElementSeparator customData={serviceOrder.children} />
        {canLoadMore && (
          <SubItem separatorWeight={2}>
            <Separator weight={4} />
            <Link onClick={() => setShowAll(true)} block>
              <Text color={COLORS.purple} size="small">
                Mostrar outros {missingLength} planos de ação
              </Text>
            </Link>
            <Separator weight={4} />
          </SubItem>
        )}
      </div>
    )
  }

  return (
    <ServiceOrdersLoader
      filter={{ parentIds: serviceOrder.id }}
      noSearch
      noFilter
      defaultSort={{ field: 'ID', type: 'ASC' }}
    >
      <ServiceOrdersTable inPanel={false} hideHeader />
    </ServiceOrdersLoader>
  )
}

export default ActionPlansTable
